module.exports = __webpack_public_path__ + "img/ico_folder_close.65d385d8.svg";